import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface FreeDownloadsStoreState {}

export default {
  namespaced: true,
  actions: {
    getFreeDownLoadCenterFilters(context: ActionContext<FreeDownloadsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `downloads/get-free-applicableSoftwareGroups?username=anonymous&source=MSW&langCode=${payload.language}&fileType=${payload.fileType}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getFreeApplicableDownloads(context: ActionContext<FreeDownloadsStoreState, RootStoreState>, payload: any) {
      payload.username = 'ANONYMOUS';
      context.commit('startLoading', null, { root: true });
      const endpoint = 'downloads/get-freeDownloads';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getDownloadTC(context: ActionContext<FreeDownloadsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `downloads/get-downloadtermsconditions?username=${payload.username}&swID=${payload.swID}&tncID=${payload.tncID}&oemCode=SNWL`;
      return ApiServiceWrapper.get(endpoint);
    },
  },
} as Module<FreeDownloadsStoreState, RootStoreState> ;
